import "moment-timezone";
import React, { Component } from "react";
import Moment from 'react-moment';

class ZoomRecordsTable extends Component {
  constructor(props) {
    super(props);
    this.state = { items: props.items };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.items !== prevProps.items) {
      this.setState({ items: this.props.items })
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return nextProps.items === prevState.items
      ? {}
      : { items: nextProps.items };
  }

  handleSelectChange = (event, id) => {
    const checked = event.target.checked;
    this.changeSelectedState(id, checked)
  }

  changeSelectedState = (id, checked) => {
    this.props.itemSelectStateChanged(id, checked)
  }

  handleSelectAllChange = (event) => {
    if (this.state.checkedSelectAll) {
      this.props.itemSelectAllChanged(false)
      this.setState({ checkedSelectAll: false })
    } else {
      this.props.itemSelectAllChanged(true)
      this.setState({ checkedSelectAll: true })
    }
  }

  render() {
    const ZoomRecordsTable = props => {
      return (
        <tbody>
          {props.items.map(item => (
            <ZoomRecordsTableItem
              key={item.id}
              item={item}
              handleViewClick={this.handleViewClick}
            />
          ))}
        </tbody>
      );
    };

    const ZoomRecordsTableHeader = props => {
      return (
        <thead className='dark'>
          <tr>
            <th style={{ width: 10 }}>ID</th>
            <th>Host</th>
            <th>Topic</th>
            <th>At</th>
            <th>Type</th>
            <th>Duration</th>
            <th>Link</th>
          </tr>
        </thead>
      );
    };

    const ZoomRecordsTableItem = props => {
      const zoom_record = props.item
      return (
        <tr>
          <td data-label="ID">
            #{zoom_record.id}
          </td>
          <td data-label="Host">
            {zoom_record.host_email}
          </td>
          <td data-label="Topic">
            {zoom_record.topic}
          </td>
          <td data-label="At">
            <Moment format="MMM Do YYYY h:mma">{zoom_record.start_time}</Moment>
          </td>
          <td data-label="Type">
            {zoom_record.recording_type}
          </td>
          <td data-label="Duration">
            {zoom_record.duration}
          </td>
          <td data-label="Link">
            <a href={zoom_record.url} target="_blank" rel="noopener noreferrer">Download</a>
          </td>
        </tr>
      );
    };
    return (
      <div>
        <table
          className="table table-hover table-bordered stable-condensed responsive"
          style={{ width: "100%" }}
        >
          <ZoomRecordsTableHeader />
          <ZoomRecordsTable items={this.state.items} />
        </table>
      </div>
    );
  }
}

export default (ZoomRecordsTable)